import { render, staticRenderFns } from "./NotificationEdit.vue?vue&type=template&id=0ea021f8&scoped=true&lang=pug&"
import script from "./NotificationEdit.vue?vue&type=script&lang=ts&"
export * from "./NotificationEdit.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationEdit.vue?vue&type=style&index=0&id=0ea021f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea021f8",
  null
  
)

export default component.exports